export const reportDateFormat = 'DD MMM YYYY HH:mm'
export const reportDateFormatNoTime = 'DD MMM YYYY'
